export default function Fotos() {
  return (
    <section className="section static-light" id="fotos">
      <div className="container">
        <h2 className="h2">RIDERS EM AÇÃO</h2>

        <div className="row">
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div>
              <picture>
                <source srcSet="/media/gallery/foto1.webp" type="image/webp" />
                <img
                  src="/media/gallery/foto1.jpeg"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p1_jHtDC-8sA.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p1_jHtDC-8sA.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p1_jHtDC-8sA.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p1_jHtDC-8sA.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p1_jHtDC-8sA.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p2_h1zINNcji.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p2_h1zINNcji.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p2_h1zINNcji.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p2_h1zINNcji.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p2_h1zINNcji.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p3_oUtqd2qM9_.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p3_oUtqd2qM9_.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p3_oUtqd2qM9_.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p3_oUtqd2qM9_.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p3_oUtqd2qM9_.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p4_mQh4WOkn2I.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p4_mQh4WOkn2I.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p4_mQh4WOkn2I.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p4_mQh4WOkn2I.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p4_mQh4WOkn2I.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
          </div>

          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div>
              <picture>
                <source srcSet="/media/gallery/foto2.webp" type="image/webp" />
                <img
                  src="/media/gallery/foto2.jpeg"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p5_MYPbwU9Rl.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p5_MYPbwU9Rl.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p5_MYPbwU9Rl.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p5_MYPbwU9Rl.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p5_MYPbwU9Rl.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p6_-3nTyAfQV.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p6_-3nTyAfQV.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p6_-3nTyAfQV.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p6_-3nTyAfQV.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p6_-3nTyAfQV.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p7_XSEFsJOxF6.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p7_XSEFsJOxF6.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p7_XSEFsJOxF6.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p7_XSEFsJOxF6.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p7_XSEFsJOxF6.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p8_C1-iYYuFE.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p8_C1-iYYuFE.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p8_C1-iYYuFE.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p8_C1-iYYuFE.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p8_C1-iYYuFE.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div>
              <picture>
                <source srcSet="/media/gallery/foto4.webp" type="image/webp" />
                <img
                  src="/media/gallery/foto4.jpeg"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p9_h-dlxV6OWg.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p9_h-dlxV6OWg.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p9_h-dlxV6OWg.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p9_h-dlxV6OWg.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p9_h-dlxV6OWg.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p10_8KcJWf2gTN.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p10_8KcJWf2gTN.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p10_8KcJWf2gTN.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p10_8KcJWf2gTN.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p10_8KcJWf2gTN.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p11_ITEwFds7p.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p11_ITEwFds7p.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p11_ITEwFds7p.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p11_ITEwFds7p.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p11_ITEwFds7p.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>

            <div>
              <picture>
                <source
                  srcSet="https://ik.imagekit.io/hzsyirayf3r/gallery/p12_w5YKhWIbH.jpg?tr=w-1440,h-960 1440w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p12_w5YKhWIbH.jpg?tr=w-720,h-480 720w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p12_w5YKhWIbH.jpg?tr=w-480,h-320 480w,
          https://ik.imagekit.io/hzsyirayf3r/gallery/p12_w5YKhWIbH.jpg?tr=w-360,h-240 360w"
                  sizes="(min-width: 992px) 33vw, 100vw"
                  type="image/webp"
                />

                <img
                  src="https://ik.imagekit.io/hzsyirayf3r/gallery/p12_w5YKhWIbH.jpg?tr=w-1440,h-960"
                  width="360"
                  height="240"
                  alt=""
                  className="w-100 h-100 shadow-1-strong rounded mb-4 gallery-img"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
      <a href="#top-bar" className="back-top a-dark">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-arrow-up-circle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z" />
        </svg>
      </a>
    </section>
  );
}
